import { Grid } from '@mui/material'
import Dropzone from 'react-dropzone-uploader'
import { useTranslation } from 'react-i18next'
import 'react-dropzone-uploader/dist/styles.css'
import { Dispatch, SetStateAction } from 'react'
import { RemoveContent } from '../../../../../shared/components/inputs/Dropzone'
import { IOffer } from '../../../models/offers'

interface OffersModalDownloadableTabProps {
  offerState: IOffer
  setOfferState: Dispatch<SetStateAction<IOffer>>
}

const OffersModalDownloadableTab = ({ offerState, setOfferState }: OffersModalDownloadableTabProps) => {
  const { t } = useTranslation(['global'])

  const getUploadParams =
    (type: number) =>
    ({ meta }: any) => {
      let tmpFileNames = [...offerState.filesNames]
      tmpFileNames.push({ name: meta.name, type })
      setOfferState({ ...offerState, filesNames: tmpFileNames })
      return { url: `${import.meta.env.VITE_API_URL}/offers/upload/${meta.name}` }
    }

  const removeFileDropzone = (type: number) => (index: number) => {
    const copyFilesNames = [...offerState.filesNames]
    const filesNamesOfType = copyFilesNames.filter(file => file.type === type)
    const filesNamesNotType = copyFilesNames.filter(file => file.type !== type)
    filesNamesOfType.splice(index, 1)
    setOfferState({ ...offerState, filesNames: [...filesNamesOfType, ...filesNamesNotType] })
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {offerState.id !== null && (
          <RemoveContent
            files={offerState.filesNames.filter(file => file.type === 1).map(file => `${import.meta.env.VITE_AWS_URL}/offers/${file.name}`)}
            onHandleClick={removeFileDropzone(1)}
          />
        )}
        <Dropzone
          getUploadParams={getUploadParams(1)}
          classNames={{ dropzone: 'dzu-dropzone-custom', inputLabel: 'dzu-inputlabel-custom' }}
          inputContent={t('dropzone-drop-text')}
          maxFiles={10}
        />
      </Grid>
    </Grid>
  )
}

export default OffersModalDownloadableTab
